// QR Kiosk v2 — overlay portal target (Round-6, root cause A). All fixed-position
// overlays (Radix dialogs, the MIDAS takeover, image viewers, field editors) PORTAL
// into the kiosk layout root so they are (a) inside the .qr-kiosk-v2-root token scope
// AND (b) OUTSIDE any animated page subtree. A running/filled transform animation
// (kv2-enter / kv2-sheet-up with fill-mode: both) makes its element a containing block
// for position:fixed descendants, silently converting `fixed` → `absolute` in document
// coordinates — that is what broke the field editors / MIDAS takeover.
//
// This REVERSES the earlier "no Portal" precedent: that precedent existed ONLY to keep
// the CSS-var token scope (Radix's default portal mounts on document.body where the
// tokens do not resolve). Portaling to the SCOPED root preserves the tokens AND escapes
// the animated subtree — both reasons satisfied.
import React from "react";

/** The kiosk layout root element (`.qr-kiosk-v2-root`) — the portal container +
 *  fixed-positioning containing-block anchor for every v2 overlay. `null` for the
 *  single frame before the layout mounts (overlays render nothing until then; the
 *  layout always mounts before any page, so in practice a consumer always finds it). */
export const KioskOverlayContext = React.createContext<HTMLElement | null>(null);

/** Read the kiosk overlay/portal root from context. */
export const useKioskOverlayRoot = (): HTMLElement | null => React.useContext(KioskOverlayContext);
